/**
 * Safe path(+query) for request-access SPA post-OAuth redirects.
 * Must stay identical across **`apps/web`** OAuth initiation/callback and the SPA **`/signin`** allowlist.
 */
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const QUERY_SUFFIX = "(?:\\?[a-zA-Z0-9\\-._~!$&'()*+,;=:?/@%]*)?";
const REQUEST_ACCESS_ORG_RELATIVE_RE = new RegExp(`^/request-access/${UUID}${QUERY_SUFFIX}$`, 'i');
const REQUEST_ACCESS_WORK_ITEM_RELATIVE_RE = new RegExp(`^/request-access/work-item/${UUID}${QUERY_SUFFIX}$`, 'i');
/**
 * Validates a same-origin-relative request-access path.
 *
 * Accepts **`unknown`** so callers using **`req.query['return_to']`** can thread through without coercion.
 */
export function parseSafeRequestAccessReturnPath(raw) {
    if (typeof raw !== 'string' || raw.length === 0 || raw.length > 2048) {
        return null;
    }
    if (raw.includes('://') || raw.startsWith('//')) {
        return null;
    }
    if (!raw.startsWith('/')) {
        return null;
    }
    if (REQUEST_ACCESS_ORG_RELATIVE_RE.test(raw) || REQUEST_ACCESS_WORK_ITEM_RELATIVE_RE.test(raw)) {
        return raw;
    }
    return null;
}
//# sourceMappingURL=request-access-return-to.js.map